import { put, takeLatest, delay } from "redux-saga/effects";
import { postRegisterApi } from "store/api/LoginApi";
import { REGISTER_ACTION } from "../../actions/LoginPageAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* showMessage(isError, message) {
	const alert = { isError: isError, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* postRegister(action) {
	const { data, onSuccess } = action.params;
	yield put(globalAction.openLoadingPage());
	const res = yield postRegisterApi(data);
	try {
		if (res?.code === 0) {
			localStorage.setItem("token", res?.data?.token);
			onSuccess();
			yield showMessage(false, res?.message);
		} else {
			yield showMessage(true, res?.message);
		}
		yield delay(500);
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* postRegisterSaga() {
	yield takeLatest(REGISTER_ACTION, postRegister);
}

export default postRegisterSaga;
